import { render, staticRenderFns } from "./TouchScreenForBarcodeUser.vue?vue&type=template&id=580f164c&scoped=true&"
import script from "./TouchScreenForBarcodeUser.vue?vue&type=script&lang=js&"
export * from "./TouchScreenForBarcodeUser.vue?vue&type=script&lang=js&"
import style0 from "./TouchScreenForBarcodeUser.vue?vue&type=style&index=0&id=580f164c&scoped=true&lang=css&"
import style1 from "./TouchScreenForBarcodeUser.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f164c",
  null
  
)

export default component.exports